export function formatHashrate(value: number): string {
  if (value >= 1e18) {
    return `${(value / 1e18).toFixed(2)} EH/s`
  } else if (value >= 1e15) {
    return `${(value / 1e15).toFixed(2)} PH/s`
  } else if (value >= 1e12) {
    return `${(value / 1e12).toFixed(2)} TH/s`
  } else if (value >= 1e9) {
    return `${(value / 1e9).toFixed(2)} GH/s`
  } else if (value >= 1e6) {
    return `${(value / 1e6).toFixed(2)} MH/s`
  } else if (value >= 1e3) {
    return `${(value / 1e3).toFixed(2)} KH/s`
  }
  return `${value.toFixed(2)} H/s`
}

export function formatBitcoin(sats: number): string {
  const btc = sats / 1e8
  if (btc >= 1) {
    return `${btc.toFixed(4)} BTC`
  } else if (btc >= 0.01) {
    return `${btc.toFixed(6)} BTC`
  } else {
    return `${sats.toLocaleString()} sats`
  }
}

export function formatSatsPerByte(value: number): string {
  return `${value.toFixed(1)} sat/vB`
}

export function formatTime(seconds: number): string {
  if (seconds < 0) return 'now'
  
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)
  
  if (days > 0) {
    return `${days}d ${hours % 24}h`
  } else if (hours > 0) {
    return `${hours}h ${minutes % 60}m`
  } else if (minutes > 0) {
    return `${minutes}m ${Math.floor(seconds % 60)}s`
  } else {
    return `${Math.floor(seconds)}s`
  }
}

export function formatPercentage(value: number): string {
  return `${value >= 0 ? '+' : ''}${value.toFixed(2)}%`
}

export function formatBytes(bytes: number): string {
  if (bytes >= 1e9) {
    return `${(bytes / 1e9).toFixed(2)} GB`
  } else if (bytes >= 1e6) {
    return `${(bytes / 1e6).toFixed(2)} MB`
  } else if (bytes >= 1e3) {
    return `${(bytes / 1e3).toFixed(2)} KB`
  }
  return `${bytes} B`
}

export function formatNumber(value: number, decimals = 0): string {
  return value.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
}

export function truncateHash(hash: string, length = 8): string {
  if (hash.length <= length * 2) return hash
  return `${hash.slice(0, length)}...${hash.slice(-length)}`
}

export function formatTimestamp(timestamp: number): string {
  const date = new Date(timestamp)
  const now = Date.now()
  const diff = now - timestamp
  
  if (diff < 60 * 1000) {
    return 'just now'
  } else if (diff < 60 * 60 * 1000) {
    const minutes = Math.floor(diff / (60 * 1000))
    return `${minutes}m ago`
  } else if (diff < 24 * 60 * 60 * 1000) {
    const hours = Math.floor(diff / (60 * 60 * 1000))
    return `${hours}h ago`
  } else {
    return date.toLocaleDateString()
  }
}